import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import './styles/modal-overlay.scss';
import { zIndexStart } from './constants';

const ModalContext = React.createContext();

export const useModal = () => {
    return useContext(ModalContext);
};

let keys = 0;

const ModalProvider = ({children}) => {
    const [modals, setModals] = useState([]);

    const pushModal = (modalElement, identifier) => {
        setModals(currentModals => {
            const newModal = <div
                key={keys++}
                className='modal-overlay'
                style={{
                    zIndex: zIndexStart + currentModals.length + 1,
                }}>
                    {modalElement}
                </div>;

            return [...currentModals, { element: newModal, identifier }];
        });
    };
    const popModal = (numberOfModalsToRemove) => {
        const remove = isNaN(numberOfModalsToRemove) ? 1 : numberOfModalsToRemove;
        setModals(currentModals => {
            for (let i = 0; i < remove; i++) {
                currentModals.pop();
            }

            return [...currentModals];
        });
    };

    const removeModalsWithId = (modalIdentifier) => {
        setModals(currentModals => currentModals.filter(modal => modal.identifier !== modalIdentifier));
    };

    const isModalOpen = (modalIdentifier) => Boolean(modals.find(obj => obj.identifier === modalIdentifier));

    return (
        <ModalContext.Provider value={{modals, pushModal, popModal, removeModalsWithId, isModalOpen}}>
            {children}
        </ModalContext.Provider>
    );
};

ModalProvider.propTypes = {
    children: PropTypes.instanceOf(Object).isRequired,
};

export default ModalProvider;
